import { ContactUsModal } from '@/components/ContactUsModal'
import { LinkButton } from '@/components/ui/link-button'
import Image from 'next/image'
import Link from 'next/link'

const Header = () => {
  return (
    <header className='w-full bg-white'>
      <div className='flex justify-between items-center h-16 md:h-20 bg-white px-4 sm:px-6 lg:px-8 xl:px-12 lp-container'>
        <Link href='/' className='cursor-pointer'>
          <Image
            src='/images/rtsc_logo.svg'
            alt='RTSC Logo'
            width={100}
            height={100}
            className='w-16 h-auto sm:w-20 md:w-24 lg:w-28'
          />
        </Link>

        <div className='flex items-center gap-1 sm:gap-2 md:gap-12'>
          {/* About Us - No text wrapping, always on single line */}
          <LinkButton
            href='/about-us'
            variant='ghost'
            size='sm'
            className='text-neutral-800 rounded-none border-b-0 border-t-0 border-l-0 border-r-0 hover:bg-gray-50 text-xs sm:text-sm lg:text-base whitespace-nowrap px-2 py-0 font-semibold'
            prefetch={false}
          >
            About Us
          </LinkButton>

          {/* Contact Us Modal */}
          <ContactUsModal>
            <button
              type='button'
              className='text-neutral-800 hover:bg-gray-50 text-xs sm:text-sm lg:text-base whitespace-nowrap px-2 py-0 font-semibold transition-colors'
            >
              Contact Us
            </button>
          </ContactUsModal>

          {/* Sign In Button - Full text on all screens */}
          <div className='flex items-center gap-4'>
            <LinkButton
              href='/signin'
              variant='outline'
              size='sm'
              className='border-neutral-800 text-neutral-800 hover:bg-gray-50 text-xs sm:text-sm lg:text-base px-1 sm:px-2 md:px-3 lg:px-4 xl:px-6 w-14 sm:w-16 md:w-20 lg:w-24 xl:w-[190px] whitespace-nowrap'
            >
              Sign In
            </LinkButton>

            {/* Sign Up Button - Full text on all screens */}
            <LinkButton
              href='/signup'
              size='sm'
              className='bg-neutral-800 text-white hover:bg-neutral-700 text-xs sm:text-sm lg:text-base px-1 sm:px-2 md:px-3 lg:px-4 xl:px-6 w-14 sm:w-16 md:w-20 lg:w-24 xl:w-[190px] whitespace-nowrap'
            >
              Sign Up
            </LinkButton>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
